import React from 'react';
const links = [{
  label: 'Términos y condiciones',
  href: '#terminos'
}, {
  label: 'Política de privacidad',
  href: '#privacidad'
}, {
  label: 'Política de reembolso',
  href: '#reembolso'
}, {
  label: 'Contacto / Soporte',
  href: '#soporte'
}];
export function Footer() {
  return <footer className="border-t border-ink-line bg-ink pb-24 pt-12 text-cream md:pb-12" data-id="element-43" data-mp="2a608xzaakn9u">
      <div className="mx-auto max-w-5xl px-5 md:px-8" data-id="element-44" data-mp="1mg5yfodg3asr">
        <p className="font-display text-sm font-black uppercase tracking-wide text-white" data-id="element-45" data-mp="1mgnykw38a95y">
          Carpintería Plegable PRO™
        </p>

        <nav aria-label="Enlaces legales" className="mt-6" data-id="element-46" data-mp="1w5z7ahm7dbtb">
          <ul className="flex flex-wrap gap-x-6 gap-y-3" data-id="element-47" data-mp="1w7iqoh35o2zb">
            {links.map(link => <li key={link.label} data-id="element-48" data-mp="1rdo8xj741y2v">
                <a href={link.href} className="text-xs text-cream/60 underline-offset-4 transition-colors duration-150 hover:text-cream hover:underline md:text-sm" data-id="element-49" data-mp="13poi6j9su7oa">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="mt-8 border-t border-ink-line pt-6" data-id="element-50" data-mp="1iivza7qbfgb9">
          <p className="text-xs text-cream/50" data-id="element-51" data-mp="1ihb3yfw6ftcc">
            © 2026 Carpintería Plegable PRO™. Todos los derechos reservados.
          </p>
          <p className="mt-3 max-w-2xl text-[11px] leading-relaxed text-cream/35" data-id="element-52" data-mp="1s9qlxd7h4hx8">
            Los resultados obtenidos al aplicar el contenido pueden variar según
            experiencia, herramientas, materiales, mercado y ejecución. No se
            garantizan resultados económicos específicos.
          </p>
        </div>
      </div>
    </footer>;
}